import * as React from 'react';
import * as styles from './HomeownerBlockAside.css';
import { GreenTick } from '../Icons';
import { Avatar } from '../../common/components/avatar';
import { createAgentIdName } from '../../utils/createAgentIdName';
import { getAgentAvatar } from '../../utils/getAgentAvatar';
import { IOfferSchema, IAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { HOMEOWNER_PROOF_TEXTS } from '../../constants/homeownerProofTexts';

export interface IHomeownerBlockAsideProps {
  offer: IOfferSchema;
  agent: IAgentSchema | null;
}

export const HomeownerBlockAside = (props: IHomeownerBlockAsideProps) => {
  const { offer, agent } = props;
  const { homeownerProofs } = offer;

  if (!agent) {
    return null;
  }

  const userIdName = createAgentIdName(agent);
  const avatar = getAgentAvatar(agent);

  return (
    <div className={styles['wrapper']}>
      <Avatar
        url={avatar}
        className={styles['image']}
        isRoundness
      />

      <div className={styles['title']}>Собственник</div>

      <div className={styles['id']}>{userIdName}</div>

      {Array.isArray(homeownerProofs) && homeownerProofs.length > 0 && (
        <ul className={styles['proofs']}>
          {homeownerProofs.map((proof) => (
            <li className={styles['proof']} key={proof}>
              <GreenTick />
              {HOMEOWNER_PROOF_TEXTS[proof]}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
